import type { Icon } from '@/shared/registry'
import type { ReactNode } from 'react'

import { cn } from '@/shared/ui'

/**
 * Says there is nothing to show, in the dashed box the mockups use for an empty result
 * (`site-administration/AdminHome.jsx`). `action` is an optional next step, such as a button.
 */
export function EmptyState(props: {
  readonly children: ReactNode
  readonly icon?: Icon
  readonly action?: ReactNode
  readonly className?: string
}) {
  const { icon: Icon } = props

  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3 rounded border border-dashed border-line px-4 py-16 text-center text-text-secondary',
        props.className,
      )}
    >
      {Icon !== undefined && <Icon size={32} className="text-text-light" />}
      <p className="text-sm">{props.children}</p>
      {props.action}
    </div>
  )
}
